import { render } from "./AdminElements.vue?vue&type=template&id=4f13b959&scoped=true"
import script from "./AdminElements.vue?vue&type=script&lang=js"
export * from "./AdminElements.vue?vue&type=script&lang=js"

import "./AdminElements.vue?vue&type=style&index=0&id=4f13b959&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f13b959"]])

export default __exports__